import { AbstractControl, ValidatorFn } from "@angular/forms";

export const notEmptyValidator: ValidatorFn = (control: AbstractControl) => {
    if (!control.value || control.value.toString().trim().length === 0) {
        return { required: true };
    }
    return null;
};